// Copyright 2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import _ from 'lodash'

export const awsRegion = _.get(window, 'config.region')
export const adminGroupName = _.get(window, 'config.adminGroupName')
export const userGroupName = _.get(window, 'config.userGroupName')

let apiBaseUrl

export function initApiGatewayClient () {
  // Allow config.js to set apiBaseUrl directly (used for local development)
  const configApiBaseUrl = _.get(window, 'config.apiBaseUrl')
  if (configApiBaseUrl) {
    apiBaseUrl = configApiBaseUrl
    return
  }
  // Build the API Gateway invoke URL from window.config
  const restApiId = _.get(window, 'config.restApiId')
  const region = _.get(window, 'config.region')
  if (restApiId && region) {
    apiBaseUrl = `https://${restApiId}.execute-api.${region}.amazonaws.com/prod`
  }
}

function getAuthHeaders () {
  const { store } = require('services/state')
  if (!store.idToken) return {}
  return {
    Authorization: store.idToken,
    'Content-Type': 'application/json'
  }
}

async function apiRequest (method, path, body) {
  if (!apiBaseUrl) {
    throw new Error('API client not initialized')
  }
  const options = {
    method,
    headers: getAuthHeaders()
  }
  if (body && (method === 'POST' || method === 'PUT')) {
    options.body = JSON.stringify(body)
  }
  const response = await fetch(`${apiBaseUrl}${path}`, options)
  const data = await response.json().catch(() => ({}))
  if (!response.ok) {
    const error = new Error(data.message || `API request failed: ${response.status}`)
    error.data = data
    throw error
  }
  return { data }
}

const clientProxy = {
  get: (path, params, additionalParams, body) => apiRequest('GET', path, null),
  post: (path, params, body, additionalParams) => apiRequest('POST', path, body),
  put: (path, params, body, additionalParams) => apiRequest('PUT', path, body),
  delete: (path, params, body, additionalParams) => apiRequest('DELETE', path, body)
}

export function apiGatewayClient () {
  return Promise.resolve(clientProxy)
}

export function apiGatewayClientWithCredentials () {
  return Promise.resolve(clientProxy)
}
